import '../styles/Footer.css';
const Footer = () => {
	return (
		<footer>
			<h3>
				&copy; All right Reserved, <a href="/">livmic.music.co</a> 2021
			</h3>
		</footer>
	);
};

export default Footer;
